exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer__search___3Q2na {\n  background-color: #F94144;\n  border-color: #F94144;\n  margin-left: 19px;\n  padding: 10px 15px;\n  height: 50px;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.5;\n  color: #ffffff;\n  border-radius: 12px; }\n\n.footer__addMore___KQJ5u {\n  border: solid 1px #c8c7d4;\n  background-color: #f9f9f9;\n  height: 50px;\n  padding: 10px 15px;\n  border-radius: 12px; }\n  .footer__addMore___KQJ5u span {\n    margin-left: 12px;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 1.5;\n    color: #828282; }\n  .footer__addMore___KQJ5u i {\n    font-size: 16px;\n    font-weight: 800;\n    line-height: 1;\n    color: #ff4d66; }\n", ""]);

// exports
exports.locals = {
	"search": "footer__search___3Q2na",
	"addMore": "footer__addMore___KQJ5u"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/ModulePage/SubLevel2/SubLevel2Desktop/Footer/footer.scss
// module id = 4702
// module chunks = 6